import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core';
import { Route, Redirect } from 'react-router-dom';
import { AuthenticatedTemplate } from '@azure/msal-react';
import Header from '../../common/header/Header';
import Agentic from './Agentic';
import ValidatePermissions from '../users/ValidatePermissions';

const styles = () => ({
  contentWrapper: {
    position: 'relative',
    width: '100%',
    margin: '0 auto',
    top: 80
  }
});

@inject()
@observer
class AgenticContainer extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired
  };

  render() {
    // const { classes } = this.props;
    const mainStyle = {
      top: '4rem',
      width: ' 100%',
      margin: '0 auto',
      position: 'relative'
    };

    const showDashboardEnabled = false;

    return (
      <>
        <Header />
        <ValidatePermissions givenPermissions="admin_can_view" showDashboardEnabled={showDashboardEnabled}>
          <main style={mainStyle}>
            <Route exact path={['/', '/agentic/']}>
              <AuthenticatedTemplate>
                <Redirect to="/agentic" />
              </AuthenticatedTemplate>
            </Route>
            <Route path="/agentic" exact render={() => <Agentic {...this.props} />} />
          </main>
        </ValidatePermissions>
      </>
    );
  }
}

export default withStyles(styles)(AgenticContainer);
